import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-help-details',
  templateUrl: './help-details.component.html',
  standalone: false,
})
export class HelpDetailsComponent {
  @Input()
  empSpecificContents: { instruction: string };
}
